import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';

@Component({
  selector: 'app-info-conditions',
  templateUrl: './info-conditions.component.html',
  styleUrls: ['./info-conditions.component.scss']
})
export class InfoConditionsComponent {

  text: string = "Cargando...";
  totemActive: any = AppSettings.ENV_TOTEM;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data) {
    if (data) {
      this.text = data.text;
    }
  }
}
